export default "__VITE_ASSET__BJZLQPfp__"